import { useState } from 'react';
import { faqData } from '@/mocks/categories';

export default function FAQSection() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? faqData.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev === faqData.length - 1 ? 0 : prev + 1));
  };

  const currentFAQ = faqData[currentIndex];

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          {/* Left: Image */}
          <div className="w-full lg:w-[38%]">
            <div className="rounded-3xl overflow-hidden bg-accent-100 aspect-[4/5] relative">
              <img
                src="https://readdy.ai/api/search-image?query=Friendly%20Brazilian%20customer%20support%20specialist%20sitting%20at%20modern%20help%20desk%20with%20headset%2C%20warm%20genuine%20smile%2C%20bright%20office%20with%20tropical%20plants%20and%20natural%20light%2C%20approachable%20professional%20atmosphere%2C%20Brazilian%20workplace%20culture%2C%20colorful%20modern%20office%20interior%2C%20helpful%20customer%20service%20moment%2C%20authentic%20professional%20portrait%2C%20warm%20golden%20and%20green%20tones%2C%20real%20human%20connection%20photography&width=600&height=750&seq=faq-v2-portrait&orientation=portrait"
                alt="Equipe CSSBuy Spreadsheet"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>

          {/* Right: FAQ Display */}
          <div className="w-full lg:w-[58%] flex flex-col justify-center">
            <span className="text-accent-600 text-sm font-medium mb-3">
              (Perguntas Frequentes)
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-[42px] font-bold leading-tight mb-8">
              <span className="text-foreground-950">Tudo que você precisa</span>
              <br />
              <span className="text-foreground-400">saber sobre CSSBuy</span>
            </h2>

            {/* FAQ Content */}
            <div className="bg-background-50 rounded-2xl p-6 md:p-8 mb-6 min-h-[180px]">
              <p className="text-foreground-700 text-base md:text-lg leading-relaxed">
                "{currentFAQ.answer}"
              </p>
            </div>

            {/* Question indicator */}
            <p className="text-foreground-400 text-xs mb-4">
              {currentIndex + 1} / {faqData.length} — {currentFAQ.question}
            </p>

            {/* Navigation Arrows */}
            <div className="flex items-center gap-3">
              <button
                onClick={goToPrev}
                className="w-10 h-10 rounded-xl border border-foreground-200 flex items-center justify-center text-foreground-500 hover:border-foreground-400 hover:text-foreground-800 transition-colors duration-200 cursor-pointer"
                aria-label="Pergunta anterior"
              >
                <i className="ri-arrow-left-line text-lg"></i>
              </button>
              <button
                onClick={goToNext}
                className="w-10 h-10 rounded-full bg-foreground-950 flex items-center justify-center text-background-50 hover:bg-foreground-800 transition-colors duration-200 cursor-pointer"
                aria-label="Próxima pergunta"
              >
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
            </div>

            {/* FAQ Links */}
            <div className="flex flex-wrap gap-2 mt-6">
              {faqData.map((faq, idx) => (
                <button
                  key={idx}
                  onClick={() => setCurrentIndex(idx)}
                  className={`px-4 py-2 rounded-full text-xs font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                    idx === currentIndex
                      ? 'bg-foreground-950 text-background-50'
                      : 'bg-background-50 text-foreground-500 hover:text-foreground-800 border border-background-200'
                  }`}
                >
                  {faq.question.length > 30 ? faq.question.slice(0, 30) + '...' : faq.question}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}